import Datatable from "./datatable_controller";

// Connects to data-controller="financials-datatable"
export default class extends Datatable {
  static targets = ['filter', 'exportLink']
  static values = { exportUrl: String }

  connect() {
    super.connect();
    $(this.filterTargets).on('select2:select select2:unselect', this.filterSelected.bind(this))

    // Every draw (search, status filter, paging) re-points the Export link so a
    // click always downloads the rows currently on screen.
    if (this.dataTable) {
      this.dataTable.on('draw.dt', () => this.syncExportLink())
    }
    this.syncExportLink()
  }

  // The table sends its state as DataTables ajax data; the CSV request is a plain
  // GET, so hand it the same search term + status filter as flat query params
  // (FinancialsListingDatatable#search_term reads either shape).
  syncExportLink() {
    if (!this.hasExportLinkTarget || !this.hasExportUrlValue) return

    const url = new URL(this.exportUrlValue, window.location.origin)
    const term = (this.dataTable ? this.dataTable.search() : '').trim()
    if (term) url.searchParams.set('search', term)

    this.filterTargets.forEach((filter) => {
      const value = $(filter).val()
      if (value) url.searchParams.set(filter.name, value)
    })

    this.exportLinkTarget.href = `${url.pathname}${url.search}`
  }

  filterSelected(_event) {
    this.dataTable.draw()
  }

  manipulateData(data) {
    this.filterTargets.map((filter) => {
      data[filter.name] = $(filter).val()
    })
    return data
  }

  applyEventFilter() {
    this.dataTable.draw();
  }

  removeEventFilter() {
    this.filterTargets.forEach(cb => cb.checked = false);
    this.dataTable.draw();
  }

  get columns() {
    return [
      {data: "event_name"},
      {data: "date"},
      {data: "total_amount"},
      {data: "service_fee"},
      {data: "tax_amount"},
      {data: "net_profit"},
      {data: "status"},
    ];
  }

  get searching() {
    return true;
  }

  get ordering() {
    return false;
  }

  get lengthChange() {
    return false;
  }
}
